module.exports = __webpack_public_path__ + "static/media/install9.86474013.png";